import type { FeatureCollection } from 'geojson';

import { ajax } from 'cadenza/api-client/api';
import { MIMETYPE_GEOJSON } from 'cadenza/model/media-type';

/* @see net/disy/cadenza/gis/web/layer/feature/rest/LayerFeatureEndpointController.java */
export function updateFeaturesInLayer (layerId: string, featureCollection: FeatureCollection) {
  return ajax<void>(`/layers/${layerId}/features`, {
    type: 'PUT',
    data: JSON.stringify(featureCollection),
    contentType: MIMETYPE_GEOJSON
  });
}
